// import lottie from './lottie.min';
// import { SVG } from '@svgdotjs/svg.js';
const SceneLottie = {}; // 存储转场lottie动画信息，以便复用

class SceneEffect {
  constructor(){
    this.type = '';
    this.duration = 0;
    this.startAt = 0;
    this.pre = null;
    this.next = null;
  }
  init(pre, next) {
    this.pre = pre;
    this.next = next;
  }
  stop(){
    this.pre.show = false;
    this.next.show = true;
    this.recovery();
  }
  start() {
    this.pre.show = true;
    this.next.show = false;
    this.recovery()
  }
  getData(){
    return {
      type: this.type,
      duration: this.duration
    };
  }
  recovery() {}
  async initDom() {}
  static linear(t, b, c, d) {
    return c * (t / d) + b;
  }
  static easeOutQuad(t, b, c, d) {
    return  -c *(t/=d)*(t-2) + b;
  }
  static easeInOutSine(t, b, c, d) {
    return -c/2 * (Math.cos(Math.PI*t/d) - 1) + b;
  }
  static easeOutQuart(t, b, c, d) {
    return -c * ((t = t / d - 1) * t * t * t - 1) + b;
  }
  static easeInCubic (t, b, c, d) {
    return c * (t /= d) * t * t + b;
  }
  static makeid() {
    let text = '';
    let possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz';

    for (let i = 0; i < 5; i++)
      text += possible.charAt(Math.floor(Math.random() * possible.length));
    return text;
  }
}

class NoneSceneEffect extends SceneEffect {
  constructor() {
    super();
    this.type = 'None';
  }
  play() {
    this.next.show = true;
    this.pre.show = false;
  }
}
class ZoomInSceneEffect extends SceneEffect {
  constructor() {
    super();
    this.type = 'ZoomIn';
    this.duration = 0.5;
    this.startAt = 0.25;
  }
  play(time) {
    this.next.show = true;
    this.next.transform = `scale(${SceneEffect.linear(time, 0, 1, this.duration)})`;
    this.pre.transform = `scale(${SceneEffect.linear(time, 1, 0.25, this.duration)})`;
  }
  recovery() {
    this.next.transform = '';
    this.pre.transform = '';
  }
}
class ZoomOutSceneEffect extends SceneEffect {
  constructor() {
    super();
    this.type = 'ZoomOut';
    this.duration = 0.5;
    this.startAt = 0.25;
    this.zIndex = 0;
  }
  init(pre, next) {
    super.init(pre, next);
    this.zIndex = pre.zIndex;
  }
  play(time) {
    this.pre.show = true;
    this.next.show = true;
    this.pre.zIndex = 1999;
    this.next.transform = `scale(${SceneEffect.linear(time, 1.25, -0.25, this.duration)})`;
    this.pre.transform = `scale(${SceneEffect.linear(time, 1, -1, this.duration)})`;
  }
  recovery() {
    this.next.transform = '';
    this.pre.transform = '';
    this.pre.zIndex = this.zIndex;
  }
}
class FadeInSceneEffect extends SceneEffect {
  constructor() {
    super();
    this.type = 'FadeIn';
    this.duration = 0.5;
    this.startAt = 0.25;
    this.zIndex = 0
  }
  init(pre, next) {
    super.init(pre, next);
    this.zIndex = pre.zIndex;
  }
  play(time) {
    this.pre.show = true;
    this.next.show = true;
    this.pre.zIndex = 1999;
    this.pre.opacity = SceneEffect.linear(time, 1, -1, this.duration);
  }
  recovery() {
    this.pre.opacity = 1;
    this.pre.zIndex = this.zIndex;
  }
}

class MoveSceneEffect extends SceneEffect {
  constructor() {
    super();
    this.duration = 0.5;
    this.startAt = 0.25
    this.width = 1920;
    this.height = 1080;
  }
  recovery() {
    this.next.transform = '';
    this.pre.transform = '';
  }
}
class RightInSceneEffect extends MoveSceneEffect {
  constructor() {
    super();
    this.type = 'RightIn';
  }
  play(time){
    this.pre.show = true;
    this.next.show = true;
    this.pre.transform = `translateX(${SceneEffect.easeOutQuad(time, 0, this.width, this.duration)}px)`;
    this.next.transform = `translateX(${SceneEffect.easeOutQuad(time, -this.width, this.width, this.duration)}px)`;
  }
}
class LeftInSceneEffect extends MoveSceneEffect {
  constructor() {
    super();
    this.type = 'LeftIn';
  }
  play(time){
    this.pre.show = true;
    this.next.show = true;
    this.pre.transform = `translateX(${SceneEffect.easeOutQuad(time, 0, -this.width, this.duration)}px)`;
    this.next.transform = `translateX(${SceneEffect.easeOutQuad(time, this.width, -this.width, this.duration)}px)`;
  }
}
class UpInSceneEffect extends MoveSceneEffect {
  constructor() {
    super();
    this.type = 'UpIn';
  }
  play(time){
    this.pre.show = true;
    this.next.show = true;
    this.pre.transform = `translateY(${SceneEffect.easeOutQuad(time, 0, -this.height, this.duration)}px)`;
    this.next.transform = `translateY(${SceneEffect.easeOutQuad(time, this.height, -this.height, this.duration)}px)`;
  }
}
class DownInSceneEffect extends MoveSceneEffect {
  constructor() {
    super();
    this.type = 'DownIn';
  }
  play(time){
    this.pre.show = true;
    this.next.show = true;
    this.pre.transform = `translateY(${SceneEffect.easeOutQuad(time, 0, this.height, this.duration)}px)`;
    this.next.transform = `translateY(${SceneEffect.easeOutQuad(time, -this.height, this.height, this.duration)}px)`;
  }
}

class LottieSceneEffect extends SceneEffect {
  constructor(){
    super();
    this.duration = 1;
    this.maskEle = null;
    this.lottie = null; // lottie控制对象
    this.frameRate = 0;
    this.totalFrames = 0;
    this.lottieUrl = '';
    this.width = 1920;
    this.height = 1080;

    this.startAt = 0;
    this.pLeft = 0;
  }
  async initDom(optimized) {
    if(SceneLottie[`${this.type}D`]) {
      this.lottie = SceneLottie[`${this.type}L`];
      this.maskEle = SceneLottie[`${this.type}D`];
      this.frameRate = this.lottie.frameRate;
      this.totalFrames = this.lottie.totalFrames;
      return;
    }
    let dom = document.getElementById('editor-scene-mask');
    let mask = document.createElement('div');
    mask.setAttribute('id', `lottie_${this.type}`);
    this.lottieUrl = `/static/animengine/js/scene-effects/lotties/${this.type}${optimized === 'Vertical'? optimized : ''}.json`;
    mask.setAttribute('data-animation-path', this.lottieUrl);
    mask.setAttribute('data-anim-type', 'svg');
    mask.setAttribute('data-anim-autoplay', false);
    mask.setAttribute('data-anim-loop', false);
    mask.setAttribute('data-anim-prerender', true);
    mask.style.position = 'absolute';
    mask.style.width = `${optimized === 'Vertical' ? this.height*9/16 : this.width}px`;
    mask.style.height = `${this.height}px`;
    this.pLeft = optimized === 'Vertical' ? this.height*175/288 : 0
    mask.style.left = `${this.pLeft}px`;
    mask.style.display = 'none';

    dom.appendChild(mask);
    let lottiePro = new Promise((resolve) => {
      let instance = lottie.registerAnimation(mask);

      instance.addEventListener('DOMLoaded', () => {
        instance.isDOMLoaded = true;
        this.frameRate = instance.frameRate;
        this.totalFrames = instance.totalFrames;
        resolve(instance);
      });
    });
    this.lottie = await lottiePro;
    this.maskEle = mask;
    SceneLottie[`${this.type}L`] = this.lottie;
    SceneLottie[`${this.type}D`] = mask;
  }
  play(time) {
    this.maskEle.style.display = '';
    this.lottie.setCurrentRawFrameValue(Math.floor(time * this.frameRate));
    if(time < this.startAt) {
      this.next.show =false;
      this.pre.show = true;
    } else {
      this.next.show = true;
      this.pre.show = false;
    }
  }
  recovery() {
    this.maskEle.style.display = 'none';
  }
}
class ClipboardSceneEffect extends LottieSceneEffect {
  constructor() {
    super();
    this.type = 'Clipboard'; // 电影打板
    this.duration = 1.28;
    this.startAt = 0.8;
  }
}
class PoofSceneEffect extends LottieSceneEffect {
  constructor() {
    super();
    this.type = 'Poof'; // 爆出
    this.duration = 0.76;
    this.startAt = 0.15;
  }
}
class SpiralzSceneEffect extends LottieSceneEffect {
  constructor() {
    super();
    this.type = 'Spiralz'; // 灰色螺旋
    this.duration = 1.56;
    this.startAt = 0.7;
  }
}
class SpiralzTechSceneEffect extends LottieSceneEffect {
  constructor() {
    super();
    this.type = 'SpiralzTech'; // 蓝色螺旋
    this.duration = 1.56;
    this.startAt = 0.7;
  }
}
class RollerSceneEffect extends LottieSceneEffect {
  constructor() {
    super();
    this.type = 'Roller'; // 滚筒刷
    this.duration = 2.06;
    this.startAt = 1.3;
  }
}
class SqweegeeSceneEffect extends LottieSceneEffect {
  constructor() {
    super();
    this.type = 'Sqweegee'; // 玻璃刮
    this.duration = 1.84;
    this.startAt = 1.00;
  }
}
class BlueColorSmearSceneEffect extends LottieSceneEffect {
  constructor() {
    super();
    this.type = 'BlueColorSmear'; // 蓝色涂抹
    this.duration = 1.36;
    this.startAt = 0.70;
  }
}
class WhiteColorSmearSceneEffect extends LottieSceneEffect {
  constructor() {
    super();
    this.type = 'WhiteColorSmear'; // 白色涂抹
    this.duration = 1.36;
    this.startAt = 0.70;
  }
}
class HandsSceneEffect extends LottieSceneEffect {
  constructor() {
    super();
    this.type = 'Hands'; // 手势下移
    this.duration = 0.90;
    this.startAt = 0.45;
  }
  play(time) {
    this.pre.show = true;
    this.lottie.setCurrentRawFrameValue(Math.floor(time * this.frameRate));
    if(time >= this.startAt) {
      let dy = SceneEffect.linear(time - this.startAt, 0, this.height, this.startAt);
      this.next.show = true;
      this.pre.transform = `translateY(${dy}px)`;
      this.next.transform = `translateY(${SceneEffect.linear(time - this.startAt, -this.height, this.height, this.startAt)}px)`;
      this.maskEle.style.transform = `translateY(${dy}px)`;
    }
    this.maskEle.style.display = '';
  }
  recovery() {
    this.next.transform = '';
    this.pre.transform = '';
    this.maskEle.style.transform = `translateY(0px)`;
    this.maskEle.style.display = 'none';
  }
}
class PullDownSceneEffect extends LottieSceneEffect {
  constructor() {
    super();
    this.type = 'PullDown'; // 手势下移
    this.duration = 1.00;
    this.startAt = 0.85;
    this.later = 0.7;
    this.zIndex = 0;
  }
  play(time) {
    this.pre.show = true;
    this.lottie.setCurrentRawFrameValue(Math.floor(time * this.frameRate));
    if(time >= this.later) {
      this.next.transform = `translateY(${SceneEffect.easeOutQuart(time - this.later, -this.height, this.height, this.duration - this.later)}px)`;
      this.maskEle.style.transform = `translateY(${SceneEffect.easeOutQuart(time - this.later, 0, this.height, this.duration - this.later)}px)`;
      this.next.show = true;
    }
    this.maskEle.style.display = '';
  }
  recovery() {
    this.next.transform = '';
    this.maskEle.style.display = 'none';
    this.maskEle.style.transform = 'translateY(0px)';
  }
}
class FanUpSceneEffect extends LottieSceneEffect {
  constructor() {
    super();
    this.type = 'FanUp'; // 手势下移
    this.duration = 1.2;
    this.startAt = 1.0;
    this.later = 0.2;
    this.zIndex = 0;
    this.dom = null;
  }
  init(pre, next) {
    super.init(pre, next);
    this.zIndex = next.zIndex;
  }
  async initDom(optimized){
    await super.initDom(optimized);
    this.dom = document.getElementById('editor-scene-mask');
  }
  play(time) {
    this.pre.show = true;
    this.dom.style.zIndex = 1899;
    this.lottie.setCurrentRawFrameValue(Math.floor(time * this.frameRate));
    if(time >= this.later) {
      this.next.show = true;
      this.next.zIndex = 1999;
      this.next.transformOrigin = `${this.pLeft}px 0px 0px`;
      this.next.transform = `rotateZ(${SceneEffect.easeInOutSine(time - this.later, 90, -90, this.duration - this.later)}deg) scale(${time/this.duration-Math.pow(time/this.duration, 2) + 1})`;
    }
    this.maskEle.style.display = '';
  }
  recovery() {
    this.next.zIndex = this.zIndex;
    this.dom.style.zIndex = 9999;
    this.next.transform = '';
    this.next.transformOrigin = '';
    this.maskEle.style.display = 'none';
  }
}
class FanDownSceneEffect extends LottieSceneEffect {
  constructor() {
    super();
    this.type = 'FanDown'; // 手势下移
    this.duration = 1.2;
    this.startAt = 1.0;
    this.later = 0.2;
    this.zIndex = 0;
    this.dom = null;
  }
  init(pre, next) {
    super.init(pre, next);
    this.zIndex = next.zIndex;
  }
  async initDom(optimized){
    await super.initDom(optimized);
    this.dom = document.getElementById('editor-scene-mask');
  }
  play(time) {
    this.pre.show = true;
    this.dom.style.zIndex = 1899;
    this.lottie.setCurrentRawFrameValue(Math.floor(time * this.frameRate));
    if(time >= this.later) {
      this.next.show = true;
      this.next.zIndex = 1999;
      this.next.transformOrigin = `${this.width-this.pLeft}px ${this.height}px 0px`;
      this.next.transform = `rotateZ(${SceneEffect.easeInOutSine(time - this.later, 90, -90, this.duration - this.later)}deg) scale(${time/this.duration-Math.pow(time/this.duration, 2) + 1})`;
    }
    this.maskEle.style.display = '';
  }
  recovery() {
    this.next.zIndex = this.zIndex;
    this.dom.style.zIndex = 9999;
    this.next.transform = '';
    this.next.transformOrigin = '';
    this.maskEle.style.display = 'none';
  }
}

class TvNoiseSceneEffect extends SceneEffect {
  constructor() {
    super();
    this.type = 'TvNoise';
    this.duration = 1.0;
    this.startAt = 0.333;
    this.later = 0.666;
    this.width = 1920 / 2;
    this.height = 1080 / 2;
    this.canvas = null;
    this.context = null;
  }
  async initDom() {
    let dom = document.getElementById('editor-scene-mask');
    let canvas = document.createElement('canvas');
    canvas.width = this.width;
    canvas.height = this.height;
    canvas.style.transformOrigin = '0 0';
    canvas.style.position = 'absolute';
    canvas.style.left = 0;
    canvas.style.transform = 'scale(2)';
    canvas.style.display = 'none';
    canvas.style.opacity = 0;

    dom.appendChild(canvas);
    this.canvas = canvas;
    this.context = canvas.getContext('2d');
  }
  play(time) {
    this.draw(time);
    this.canvas.style.display = '';
    if(time < this.startAt) {
      this.pre.show = true;
      this.next.show = false;
      this.canvas.style.opacity = SceneEffect.linear(time, 0, 1, this.startAt);
    } else if(time > this.later) {
      this.canvas.style.opacity = SceneEffect.linear(time-this.later, 1, -1, this.startAt);
      this.next.show = true;
      this.pre.show = false;
    } else {
      this.canvas.style.opacity = 1;
    }
  }
  recovery() {
    this.canvas.style.display = 'none';
    this.canvas.style.opacity = 0;
  }
  draw(time){
    let imgData = this.context.createImageData(this.width, this.height);
    let pix = imgData.data;
    for(let i = 0; i < pix.length; i += 4) {
      // 对sin函数表现效果不满意，自己定义一个概率密度函数(pdf)
      let c = 7 - TvNoiseSceneEffect.pdf(i/20/this.height, time/7, 0.6) * 4;
      c = 40 * Math.random() * c;
      pix[i] = c;
      pix[i+1] = c;
      pix[i+2] = c;
      pix[i+3] = 255;
    }
    this.context.putImageData(imgData, 0, 0);
  }
  /**
   * 概率密度函数
   * @param {*} x 相当于x变量
   * @param {*} m x轴上的偏移
   * @param {*} s 控制峰值和函数的陡峭
  */
  static pdf(x, m, s) {
    return Math.exp(-0.91893853320467274180 - Math.log(s) - Math.pow(x - m, 2) / (2 *s*s));
  }
}

class SliceSceneEffect extends SceneEffect { // 对角划像
  constructor(){
    super();
    this.type = 'Slice';
    this.duration = 0.6;
    this.startAt = 0.4;
    this.later = 0.234;
    this.width = 1920;
    this.height = 1080;
    this.maskEle = null;
    this.maskId = `slide_${SceneEffect.makeid()}_mask`;
    this.maskFir = null;
    this.maskSec = null;
    this.zIndex = 0;
  }
  async initDom() {
    let dom = document.getElementById('editor-scene-mask');
    let mask = document.createElement('div');
    mask.style.position = 'absolute';
    dom.appendChild(mask);
    let svg = SVG().addTo(mask);
    svg.size(this.width, this.height);
    let clipPath = svg.defs().clip().attr('id', this.maskId);
    this.maskFir = clipPath.rect().attr({
      y: -this.height/2,
      width: '100%', height: '200%',
      fill: 'black',
      transform: 'matrix(1,0,0,1,0,0)'
    });
    let ms = document.createElement('div');
    ms.style.position = 'absolute';
    ms.style.left = '50%';
    ms.style.top = '-25%';
    ms.style.height = '150%';
    ms.style.transform = 'rotate(30deg)';
    ms.style.width = 0;
    ms.style.background = '#ffffff';
    mask.appendChild(ms);
    mask.style.display = 'none';
    this.maskSec = ms;
    this.maskEle = mask;
  }
  init(pre, next) {
    super.init(pre, next);
    this.zIndex = pre.zIndex;
  }
  play(time) {
    let val = 0,
      val2 = 0,
      val3 = 0;
    this.next.show = true;
    this.maskEle.style.display = '';
    if(time < this.startAt) {
      this.pre.clipPath = `url("#${this.maskId}")`;
      this.pre.show = true;
      this.pre.zIndex = 1999;
      if(time < this.later) {
        val = SceneEffect.linear(time, 0, 30, this.later);
      } else {
        val = 30;
      }
      val2 = SceneEffect.linear(time, this.width, -this.width, this.startAt);
      this.pre.transform = `scale(${SceneEffect.easeInCubic(time, 1, 0.25, this.duration)})`;
      this.maskFir.attr({
        width: val2,
        x: this.width / 2 - val2 / 2,
        transform: `rotate(${val}, ${this.width/2} ${this.height/2})`
      });
      val3 = SceneEffect.linear(time, 0, this.width/9, this.startAt);
      this.maskSec.style.width = `${val3}px`;
      this.maskSec.style.left = `calc(50% + -${val3/2}px)`;
    } else {
      this.pre.show = false;
      val3 = SceneEffect.linear(time - this.startAt, this.width/9, -this.width/9, this.duration - this.startAt);
      this.maskSec.style.width = `${val3}px`;
      this.maskSec.style.left = `calc(50% + -${val3/2}px)`;
    }
    this.next.transform = `scale(${SceneEffect.easeInCubic(time, 1.25, -0.25, this.duration)})`;
  }
  recovery() {
    this.next.transform = '';
    this.pre.clipPath = '';
    this.pre.transform = '';
    this.maskEle.style.display = 'none';
    this.pre.zIndex = this.zIndex;
  }
}
class SliceHorizontalSceneEffect extends SceneEffect {
  constructor(){
    super();
    this.type = 'SliceHorizontal';
    this.duration = 0.6;
    this.startAt = 0.4;
    this.width = 1920;
    this.height = 1080;
    this.maskId = `slide_${SceneEffect.makeid()}_mask`;
    this.maskFir = null;
    this.maskSec = null;
  }
  async initDom() {
    let dom = document.getElementById('editor-scene-mask');
    let svg = SVG().addTo(dom);
    svg.hide();
    svg.size(this.width, this.height);
    let clipPath = svg.defs().clip().attr('id', this.maskId);
    this.maskFir = clipPath.rect().attr({
      x: 0, y: 0,
      width: '100%', height: '50%',
      fill: 'black',
      'data-svg-origin': '0 0',
      transform: `matrix(1,0,0,1,${this.width},0)`
    });
    this.maskSec = clipPath.rect().attr({
      x: 0, y: '50%',
      width: '100%', height: '50%',
      fill: 'black',
      'data-svg-origin': `0 ${this.height / 2}`,
      transform: `matrix(1,0,0,1,${-this.width},0)`
    });
    this.maskEle = svg;
  }
  play(time) {
    this.maskEle.show();
    this.pre.show = true;
    this.next.show = true;
    this.next.clipPath = `url("#${this.maskId}")`;
    let val = SceneEffect.easeInCubic(time, this.width, -this.width, this.duration);
    this.pre.transform = `scale(${SceneEffect.easeInCubic(time, 1, 0.25, this.duration)})`;
    this.next.transform = `scale(${SceneEffect.easeInCubic(time, 1.25, -0.25, this.duration)})`;
    this.maskFir.attr('transform', `matrix(1,0,0,1,${val},0)`);
    this.maskSec.attr('transform', `matrix(1,0,0,1,${-val},0)`);
  }
  recovery() {
    this.next.transform = '';
    this.next.clipPath = '';
    this.pre.transform = '';
    this.maskEle.hide();
  }
}
class SliceCenterSceneEffect extends SceneEffect {
  constructor(){
    super();
    this.type = 'SliceCenter';
    this.duration = 0.7;
    this.startAt = 0.2;
    this.width = 1920;
    this.height = 1080;
    this.maskId = `slide_${SceneEffect.makeid()}_mask`;
    this.maskFir = null;
    this.maskSec = null;
  }
  async initDom() {
    let dom = document.getElementById('editor-scene-mask');
    let svg = SVG().addTo(dom);
    svg.hide();
    svg.size(this.width, this.height);
    let clipPath = svg.defs().clip().attr('id', this.maskId);
    this.maskFir = clipPath.rect().attr({
      x: 0, y: 0,
      width: 0, height: '100%',
      fill: 'black',
      'data-svg-origin': '0 0',
      transform: `matrix(1,0,0,1,${this.width/2},0)`
    });
    this.maskSec = clipPath.rect().attr({
      x: '50%', y: 0,
      width: 0, height: '100%',
      fill: 'black',
      'data-svg-origin': `${this.width / 2} 0`,
      transform: 'matrix(1,0,0,1,0,0)'
    });
    this.maskEle = svg;
  }
  play(time) {
    this.maskEle.show();
    this.pre.show = true;
    this.next.show = true;
    this.next.clipPath = `url("#${this.maskId}")`;
    let val = SceneEffect.easeInCubic(time, 0, this.width/2, this.duration);
    this.pre.transform = `scale(${SceneEffect.easeInCubic(time, 1, 0.25, this.duration)})`;
    this.next.transform = `scale(${SceneEffect.easeInCubic(time, 1.25, -0.25, this.duration)})`;
    this.maskFir.attr({
      width: `${val}px`,
      transform: `matrix(1,0,0,1,${this.width / 2 - val},0)`
    });
    this.maskSec.attr('width', `${val}px`);
  }
  recovery() {
    this.next.transform = '';
    this.next.clipPath = '';
    this.pre.transform = '';
    this.maskEle.hide();
  }
}
class SliceVerticalSceneEffect extends SceneEffect {
  constructor(){
    super();
    this.type = 'SliceVertical';
    this.duration = 0.6;
    this.startAt = 0.4;
    this.width = 1920;
    this.height = 1080;
    this.maskId = `slide_${SceneEffect.makeid()}_mask`;
    this.maskFir = null;
    this.maskSec = null;
  }
  async initDom() {
    let dom = document.getElementById('editor-scene-mask');
    let svg = SVG().addTo(dom);
    svg.hide();
    svg.size(this.width, this.height);
    let clipPath = svg.defs().clip().attr('id', this.maskId);
    this.maskFir = clipPath.rect().attr({
      x: 0, y: 0,
      width: '50%', height: '100%',
      fill: 'black',
      'data-svg-origin': '0 0',
      transform: `matrix(1,0,0,1,0,${this.height})`
    });
    this.maskSec = clipPath.rect().attr({
      x: '50%', y: 0,
      width: '50%', height: '100%',
      fill: 'black',
      'data-svg-origin': `${this.width / 2} 0`,
      transform: `matrix(1,0,0,1,0,${-this.height})`
    });
    this.maskEle = svg;
  }
  play(time) {
    this.maskEle.show();
    this.pre.show = true;
    this.next.show = true;
    this.next.clipPath = `url("#${this.maskId}")`;
    let val = SceneEffect.easeInCubic(time, this.height, -this.height, this.duration);
    this.pre.transform = `scale(${SceneEffect.easeInCubic(time, 1, 0.25, this.duration)})`;
    this.next.transform = `scale(${SceneEffect.easeInCubic(time, 1.25, -0.25, this.duration)})`;
    this.maskFir.attr('transform', `matrix(1,0,0,1,0,${val})`);
    this.maskSec.attr('transform', `matrix(1,0,0,1,0,${-val})`);
  }
  recovery() {
    this.next.transform = '';
    this.next.clipPath = '';
    this.pre.transform = '';
    this.maskEle.hide();
  }
}

class MosaicSceneEffect extends SceneEffect {
  constructor(){
    super();
    this.type = 'Mosaic';
    this.duration = 1.0;
    this.startAt = 0.5;
    this.width = 1920;
    this.height = 1080;
    this.clipPath = null;
    this.maskId = `slide_${SceneEffect.makeid()}_mask`;
    this.arrC = [];
  }
  async initDom() {
    let dom = document.getElementById('editor-scene-mask');
    let svg = SVG().size(this.width, this.height).addTo(dom);
    svg.hide();
    this.clipPath = svg.defs().clip().attr('id', this.maskId);
    for(let i=0; i<25; i++) {
      for(let j=0; j<50; j++) {
        let val = i*50 + j;
        this.arrC[val] = val;
        this.clipPath.rect().hide().attr({
          x: 2*j + '%',
          y: 4*i + '%',
          width: '2.1%', height: '4.1%',
          fill: 'black',
          storke: 'none'
        });
      }
    }
    this.arrC.sort(MosaicSceneEffect.randomsort);
    this.maskEle = svg;
  }
  play(time){
    this.maskEle.show();
    this.next.show = true;
    this.pre.show = true;
    this.next.clipPath = `url("#${this.maskId}")`;
    let val = SceneEffect.linear(time, 1, 1249, this.duration);
    for(let i = this.oldI; i < val; i++){
      this.clipPath.get(this.arrC[i]).show();
    }
    this.oldI = Math.round(val);
  }
  recovery() {
    this.next.transform = '';
    this.next.clipPath = '';
    this.maskEle.hide();
    this.initClipPath();
  }
  initClipPath(){
    if(this.clipPath && this.oldI) {
      this.oldI = 0;
      for(let i=0; i< 1250; i++) {
        this.clipPath.get(i).hide();
      }
    }
  }
  static randomsort() {
    return Math.random()>.5?-1:1;
  }
}

class SwipeSceneEffect extends SceneEffect {
  constructor(){
    super();
    this.type = 'Swipe';
    this.duration = 1.5;
    this.startAt = 0.75;
    this.width = 1920;
    this.height = 1080;
    this.maskEle = null;
    this.divs = null;
    this.zIndex = 0;
  }
  async initDom(){
    let dom = document.getElementById('editor-scene-mask');
    let div = document.createElement('div');
    div.style.position = 'absolute';
    div.style.right = '0px';
    div.style.top = '0px';
    div.style.backgroundColor = '#ffffff';
    div.style.width = '0px';
    div.style.height = `${this.height}px`;
    div.style.opacity = 0.3;
    let div1 = div.cloneNode(true);
    let div2 = div.cloneNode(true);
    let maskEle = document.createElement('div');
    maskEle.style.width = `${this.width}px`;
    maskEle.style.height = `${this.height}px`;
    maskEle.style.position = 'absolute';
    maskEle.appendChild(div);
    maskEle.appendChild(div1);
    maskEle.appendChild(div2);
    maskEle.style.display = 'none';
    dom.appendChild(maskEle);
    this.divs = [div, div1, div2];
    this.maskEle = maskEle;
  }
  play(time) {
    this.maskEle.style.display = '';
    this.pre.show = true;
    if(time <= 0.35) {
      this.next.show = false;
      this.divs[0].style.width = `${SceneEffect.easeOutQuart(time, 0, this.width, 0.35)}px`;
    }
    if(time <= 0.55 && time >= 0.2) {
      this.next.show = false;
      this.divs[1].style.width = `${SceneEffect.easeOutQuart(time-0.2, 0, this.width, 0.35)}px`;
    }
    if(time < 0.75 && time >= 0.4) {
      this.next.show = false;
      this.divs[2].style.width = `${SceneEffect.easeOutQuart(time-0.4, 0, this.width, 0.35)}px`;
    }
    if(time >= 0.75) {
      this.next.show = true;
      this.divs.forEach(div => {
        div.style.width = `${SceneEffect.linear(time - 0.75, this.width, -this.width, 0.75)}px`;
      });
      let val = SceneEffect.linear(time - 0.75, 0, this.width, 0.75);
      this.next.clipPath = `polygon(0 0, ${val}px 0, ${val}px ${this.height}px, 0 ${this.height}px, 0 0)`;
    }
  }
  recovery() {
    this.maskEle.style.display = 'none';
    this.next.clipPath = '';
    this.divs.forEach(div => {
      div.style.width = '0px';
    });
  }
}

class CameraSceneEffect extends SceneEffect {
  constructor(){
    super();
    this.duration = 1.25;
    this.startAt = 0.75;
    this.firstPart = 0.5;
    this.width = 1920;
    this.height = 1080;
    this.maxZ = -1400;
  }
  recovery() {
    this.pre.transform = '';
    this.pre.transformOrigin = '';
    this.pre.transformStyle = '';
    this.pre.filter = '';
    this.next.transformOrigin = '';
    this.next.transformStyle = '';
    this.next.transform = '';
    this.next.filter = '';
  }
}
class CameraUpSceneEffect extends CameraSceneEffect{
  constructor(){
    super();
    this.type = 'CameraUp';
  }
  play(time){
    let val = 0,
      val1 = 0;
    this.pre.transformOrigin = '50% 50% 0px';
    this.pre.transformStyle = 'preserve-3d';
    this.next.transformOrigin = '50% 50% 0px';
    this.next.transformStyle = 'preserve-3d';
    this.next.show = true;
    this.pre.show = true;
    if(time < this.firstPart) {
      val = SceneEffect.linear(time, 1, -0.5, this.firstPart);
      this.pre.filter = `brightness(${val})`;
      this.pre.transform = `rotateX(${SceneEffect.linear(time, 0, 15, this.firstPart)}deg) translate3d(0px, ${SceneEffect.linear(time, 0, this.height*0.3, this.firstPart)}px, ${SceneEffect.linear(time, 0, this.maxZ, this.firstPart)}px)`;
      this.next.filter = `brightness(${val})`;
      this.next.transform = `rotateX(${SceneEffect.linear(time, -30, 15, this.firstPart)}deg) translate3d(0px, ${SceneEffect.linear(time, -this.height*1.1, this.height*0.8, this.firstPart)}px, ${SceneEffect.linear(time, this.height*0.1, this.maxZ-this.height*0.1, this.firstPart)}px)`;
    } else if(time < this.startAt) {
      this.pre.filter = 'brightness(0.5)';
      this.pre.transform = `rotateX(15deg) translate3d(0, ${this.height*0.3}px, ${this.maxZ}px)`;
      this.next.filter = 'brightness(0.5)';
      this.next.transform = `rotateX(-15deg) translate3d(0, ${-this.height*0.3}px, ${this.maxZ}px)`;
    } else {
      val = SceneEffect.linear(time-this.startAt, 0.5, 0.5, this.firstPart);
      val1 = SceneEffect.linear(time-this.startAt, this.maxZ, -this.maxZ, this.firstPart);
      this.pre.filter = `brightness(${val})`;
      this.pre.transform = `rotateX(${SceneEffect.linear(time-this.startAt, 15, 15, this.firstPart)}deg) translate3d(0px, ${SceneEffect.linear(time-this.startAt, this.height*0.3, this.height*1.1, this.firstPart)}px, ${val1}px)`;
      this.next.filter = `brightness(${val})`;
      this.next.transform = `rotateX(${SceneEffect.linear(time-this.startAt, -15, 15, this.firstPart)}deg) translate3d(0px, ${SceneEffect.linear(time-this.startAt, -this.height*0.3, this.height*0.3, this.firstPart)}px, ${val1}px)`;
    }
  }
}
class CameraDownSceneEffect extends CameraSceneEffect{
  constructor(){
    super();
    this.type = 'CameraDown';
  }
  play(time){
    let val = 0,
      val1 = 0;
    this.pre.transformOrigin = '50% 50% 0px';
    this.pre.transformStyle = 'preserve-3d';
    this.next.transformOrigin = '50% 50% 0px';
    this.next.transformStyle = 'preserve-3d';
    this.next.show = true;
    this.pre.show = true;
    if(time < this.firstPart) {
      val = SceneEffect.linear(time, 1, -0.5, this.firstPart);
      this.pre.filter = `brightness(${val})`;
      this.pre.transform = `rotateX(${SceneEffect.linear(time, 0, -15, this.firstPart)}deg) translate3d(0px, ${SceneEffect.linear(time, 0, -this.height*0.3, this.firstPart)}px, ${SceneEffect.linear(time, 0, this.maxZ, this.firstPart)}px)`;
      this.next.filter = `brightness(${val})`;
      this.next.transform = `rotateX(${SceneEffect.linear(time, 30, -15, this.firstPart)}deg) translate3d(0px, ${SceneEffect.linear(time, this.height*1.1, -this.height*0.8, this.firstPart)}px, ${SceneEffect.linear(time, this.height*0.1, this.maxZ-this.height*0.1, this.firstPart)}px)`;
    } else if(time < this.startAt) {
      this.pre.filter = 'brightness(0.5)';
      this.pre.transform = `rotateX(-15deg) translate3d(0, ${-this.height*0.3}px, ${this.maxZ}px)`;
      this.next.filter = 'brightness(0.5)';
      this.next.transform = `rotateX(15deg) translate3d(0, ${this.height*0.3}px, ${this.maxZ}px)`;
    } else {
      val = SceneEffect.linear(time-this.startAt, 0.5, 0.5, this.firstPart);
      val1 = SceneEffect.linear(time-this.startAt, this.maxZ, -this.maxZ, this.firstPart);
      this.pre.filter = `brightness(${val})`;
      this.pre.transform = `rotateX(${SceneEffect.linear(time-this.startAt, -15, -15, this.firstPart)}deg) translate3d(0px, ${SceneEffect.linear(time-this.startAt, -this.height*0.3, -this.height*1.1, this.firstPart)}px, ${val1}px)`;
      this.next.filter = `brightness(${val})`;
      this.next.transform = `rotateX(${SceneEffect.linear(time-this.startAt, 15, -15, this.firstPart)}deg) translate3d(0px, ${SceneEffect.linear(time-this.startAt, this.height*0.3, -this.height*0.3, this.firstPart)}px, ${val1}px)`;
    }
  }
}
class CameraLeftSceneEffect extends CameraSceneEffect{
  constructor(){
    super();
    this.type = 'CameraLeft';
  }
  play(time){
    let val = 0,
      val1 = 0;
    this.pre.transformOrigin = '50% 50% 0px';
    this.pre.transformStyle = 'preserve-3d';
    this.next.transformOrigin = '50% 50% 0px';
    this.next.transformStyle = 'preserve-3d';
    this.next.show = true;
    this.pre.show = true;
    if(time < this.firstPart) {
      val = SceneEffect.linear(time, 1, -0.5, this.firstPart);
      this.pre.filter = `brightness(${val})`;
      this.pre.transform = `rotateY(${SceneEffect.linear(time, 0, -15, this.firstPart)}deg) translate3d(${SceneEffect.linear(time, 0, this.width*0.35, this.firstPart)}px, 0px, ${SceneEffect.linear(time, 0, this.maxZ, this.firstPart)}px)`;
      this.next.filter = `brightness(${val})`;
      this.next.transform = `rotateY(${SceneEffect.linear(time, 30, -15, this.firstPart)}deg) translate3d(${SceneEffect.linear(time, -this.width*1.1, this.width*0.75, this.firstPart)}px, 0px, ${SceneEffect.linear(time, this.width*0.2, this.maxZ-this.width*0.2, this.firstPart)}px)`;
    } else if(time < this.startAt) {
      this.pre.filter = 'brightness(0.5)';
      this.pre.transform = `rotateY(-15deg) translate3d(${this.width*0.35}px, 0, ${this.maxZ}px)`;
      this.next.filter = 'brightness(0.5)';
      this.next.transform = `rotateY(15deg) translate3d(${-this.width*0.35}px, 0, ${this.maxZ}px)`;
    } else {
      val = SceneEffect.linear(time-this.startAt, 0.5, 0.5, this.firstPart);
      val1 = SceneEffect.linear(time-this.startAt, this.maxZ, -this.maxZ, this.firstPart);
      this.pre.filter = `brightness(${val})`;
      this.pre.transform = `rotateY(${SceneEffect.linear(time-this.startAt, -15, -15, this.firstPart)}deg) translate3d(${SceneEffect.linear(time-this.startAt, this.width*0.35, this.width*1.5, this.firstPart)}px, 0px, ${val1}px)`;
      this.next.filter = `brightness(${val})`;
      this.next.transform = `rotateY(${SceneEffect.linear(time-this.startAt, 15, -15, this.firstPart)}deg) translate3d(${SceneEffect.linear(time-this.startAt, -this.width*0.35, this.width*0.35, this.firstPart)}px, 0px, ${val1}px)`;
    }
  }
}
class CameraRightSceneEffect extends CameraSceneEffect{
  constructor(){
    super();
    this.type = 'CameraRight';
  }
  play(time){
    let val = 0,
      val1 = 0;
    this.pre.transformOrigin = '50% 50% 0px';
    this.pre.transformStyle = 'preserve-3d';
    this.next.transformOrigin = '50% 50% 0px';
    this.next.transformStyle = 'preserve-3d';
    this.next.show = true;
    this.pre.show = true;
    if(time < this.firstPart) {
      val = SceneEffect.linear(time, 1, -0.5, this.firstPart);
      this.pre.filter = `brightness(${val})`;
      this.pre.transform = `rotateY(${SceneEffect.linear(time, 0, 15, this.firstPart)}deg) translate3d(${SceneEffect.linear(time, 0, -this.width*0.35, this.firstPart)}px, 0px, ${SceneEffect.linear(time, 0, this.maxZ, this.firstPart)}px)`;
      this.next.filter = `brightness(${val})`;
      this.next.transform = `rotateY(${SceneEffect.linear(time, -30, 15, this.firstPart)}deg) translate3d(${SceneEffect.linear(time, this.width*1.1, -this.width*0.75, this.firstPart)}px, 0px, ${SceneEffect.linear(time, this.width*0.2, this.maxZ-this.width*0.2, this.firstPart)}px)`;
    } else if(time < this.startAt) {
      this.pre.filter = 'brightness(0.5)';
      this.pre.transform = `rotateY(15deg) translate3d(${-this.width*0.35}px, 0, ${this.maxZ}px)`;
      this.next.filter = 'brightness(0.5)';
      this.next.transform = `rotateY(-15deg) translate3d(${this.width*0.35}px, 0, ${this.maxZ}px)`;
    } else {
      val = SceneEffect.linear(time-this.startAt, 0.5, 0.5, this.firstPart);
      val1 = SceneEffect.linear(time-this.startAt, this.maxZ, -this.maxZ, this.firstPart);
      this.pre.filter = `brightness(${val})`;
      this.pre.transform = `rotateY(${SceneEffect.linear(time-this.startAt, 15, 15, this.firstPart)}deg) translate3d(${SceneEffect.linear(time-this.startAt, -this.width*0.35, -this.width*1.5, this.firstPart)}px, 0px, ${val1}px)`;
      this.next.filter = `brightness(${val})`;
      this.next.transform = `rotateY(${SceneEffect.linear(time-this.startAt, -15, 15, this.firstPart)}deg) translate3d(${SceneEffect.linear(time-this.startAt, this.width*0.35, -this.width*0.35, this.firstPart)}px, 0px, ${val1}px)`;
    }
  }
}

class RowSpreadSceneEffect extends SceneEffect {
  constructor() {
    super();
    this.type = 'RowSpread';
    this.duration = 1.2;
    this.startAt = 0.6;
    this.width = 1920;
    this.height = 1080;
    this.maskEle = null;
    this.sceneDom = null;
    this.zIndex = 0;
    this.noBg = false;
  }
  async initDom(){
    let dom = document.getElementById('editor-scene-mask');
    let mask = document.createElement('div');
    mask.style.position = 'absolute';
    mask.style.width = `${this.width}px`;
    mask.style.height = `${this.height}px`;
    mask.style.top = '0px';
    mask.style.left = '0px';
    mask.style.display = 'none';
    dom.appendChild(mask);
    this.maskEle = mask;
  }
  init(pre, next) {
    super.init(pre, next);
    let dom = next.cloneDom(this.noBg);
    dom.style.clipPath = 'polygon(0 0, 100% 0, 100% 16.6%, 0 16.6%, 0 33.2%, 100% 33.2%, 100% 49.8%, 0 49.8%, 0 66.4%, 100% 66.4%, 100% 83%, 0 83%, 0 66.4%, 100% 66.4%, 100% 83%, 0 83%)';
    this.maskEle.transform = `translateX(${-this.width}px)`;
    this.maskEle.appendChild(dom);
    this.maskEle.style.display = 'none';
  }
  play(time) {
    this.maskEle.style.display = '';
    if(time < this.startAt) {
      this.next.show = false;
      this.maskEle.style.transform = `translateX(${SceneEffect.linear(time, -this.width, this.width, this.startAt)}px)`;
    } else {
      this.next.show = true;
      this.maskEle.style.transform = '';
      this.next.transform = `translateX(${SceneEffect.linear(time-this.startAt, this.width, -this.width, this.startAt)}px)`;
    }
  }
  recovery() {
    this.maskEle.style.display = 'none';
    this.next.transform = '';
  }
}

class FlipBookSceneEffect extends SceneEffect {
  constructor() {
    super();
    this.type = 'FlipBook';
    this.duration = 1.5;
    this.startAt = 0.75;
    this.width = 1920;
    this.height = 1080;
    this.maskEle = null;
    this.div1 = null;
    this.div2 = null;
    this.zIndex = 0;
    this.noBg = false;
  }
  async initDom(){
    let dom = document.getElementById('editor-scene-mask');
    let mask = document.createElement('div');
    mask.style.position = 'absolute';
    mask.style.width = `${this.width}px`;
    mask.style.height = `${this.height}px`;
    mask.style.top = '0px';
    mask.style.left = '0px';
    mask.style.display = 'none';
    let div1 = mask.cloneNode();
    mask.style.perspective = '1200px';
    div1.transformStyle = 'preserve-3d';
    let div2 = div1.cloneNode();
    div1.style.clipPath = 'polygon(49.95% 0, 100% 0, 100% 100%, 49.95% 100%)';
    div1.transformOrigin = 'top left';
    div2.style.clipPath = 'polygon(0 0, 50.05% 0, 50.05% 100%, 0 100%)';
    let gradient = document.createElement('div');
    gradient.style.position = 'absolute';
    gradient.style.top = '0px';
    gradient.style.left = '50%';
    gradient.style.width = '50%';
    gradient.style.height = '100%';
    gradient.style.background = 'linear-gradient(to right, rgba(200,200,200,0.1), rgba(200,200,200,0.3))';
    div1.appendChild(gradient);
    gradient = gradient.cloneNode();
    gradient.style.left = '0';
    gradient.style.background = 'linear-gradient(to left, rgba(200,200,200,0.1), rgba(200,200,200,0.3))';
    div2.appendChild(gradient);
    mask.appendChild(div1);
    mask.appendChild(div2);
    dom.appendChild(mask);
    this.maskEle = mask;
    this.div1 = div1;
    this.div2 = div2;
  }
  init(pre, next) {
    super.init(pre, next);
    // next.play((this.duration - this.startAt) * pre.frameRate);
    next.play(0);
    let nextDom = next.cloneDom(this.noBg);
    pre.play((pre.duration - this.startAt) * pre.frameRate);
    let preDom = pre.cloneDom(this.noBg);
    pre.play(0);
    this.div1.appendChild(preDom);
    this.div2.appendChild(nextDom);
  }
  play(time) {
    this.pre.show = true;
    this.next.show = true;
    this.pre.clipPath = 'polygon(0 0, 50% 0, 50% 100%, 0 100%)';
    this.next.clipPath = 'polygon(50% 0, 100% 0, 100% 100%, 50% 100%)';
    this.maskEle.style.display = '';
    if(time < this.startAt) {
      this.div1.style.display = '';
      this.div2.style.display = 'none';
      this.div1.style.transform = `rotateY(${SceneEffect.linear(time, 0, -180, this.duration)}deg)`;
    } else {
      this.div1.style.display = 'none';
      this.div2.style.display = '';
      this.div2.style.transform = `rotateY(${SceneEffect.linear(time, 180, -180, this.duration)}deg)`;
    }
  }
  recovery() {
    this.pre.clipPath = '';
    this.next.clipPath = '';
    this.div1.style.display = 'none';
    this.div2.style.display = 'none';
    this.maskEle.style.display = 'none';
  }
}

const CreateSceneEffect = function(type) {
  let effect = null;
  switch (type) {
    case 'UpIn':
      effect = new UpInSceneEffect();
      break;
    case 'DownIn':
      effect = new DownInSceneEffect();
      break;
    case 'LeftIn':
      effect = new LeftInSceneEffect();
      break;
    case 'RightIn':
      effect = new RightInSceneEffect();
      break;
    case 'ZoomIn':
      effect = new ZoomInSceneEffect();
      break;
    case 'ZoomOut':
      effect = new ZoomOutSceneEffect();
      break;
    case 'Fade':
      effect = new FadeInSceneEffect();
      break;
    case 'Clipboard':
      effect = new ClipboardSceneEffect();
      break;
    case 'Poof':
      effect = new PoofSceneEffect();
      break;
    case 'Roller':
      effect = new RollerSceneEffect();
      break;
    case 'Sqweegee':
      effect = new SqweegeeSceneEffect();
      break;
    case 'BlueColorSmear':
      effect = new BlueColorSmearSceneEffect();
      break;
    case 'WhiteColorSmear':
      effect = new WhiteColorSmearSceneEffect();
      break;
    case 'Hands':
      effect = new HandsSceneEffect();
      break;
    case 'PullDown':
      effect = new PullDownSceneEffect();
      break;
    case 'FanDown':
      effect = new FanDownSceneEffect();
      break;
    case 'FanUp':
      effect = new FanUpSceneEffect();
      break;
    case 'TvNoise':
      effect = new TvNoiseSceneEffect();
      break;
    case 'SliceVertical':
      effect = new SliceVerticalSceneEffect();
      break;
    case 'SliceHorizontal':
      effect = new SliceHorizontalSceneEffect();
      break;
    case 'SliceCenter':
      effect = new SliceCenterSceneEffect();
      break;
    case 'Slice':
      effect = new SliceSceneEffect();
      break;
    case 'Swipe':
      effect = new SwipeSceneEffect();
      break;
    case 'CameraUp':
      effect = new CameraUpSceneEffect();
      break;
    case 'CameraDown':
      effect = new CameraDownSceneEffect();
      break;
    case 'CameraLeft':
      effect = new CameraLeftSceneEffect();
      break;
    case 'CameraRight':
      effect = new CameraRightSceneEffect();
      break;
    case 'SpiralzTech':
      effect = new SpiralzTechSceneEffect();
      break;
    case 'Spiralz':
      effect = new SpiralzSceneEffect();
      break;
    case 'FlipBook':
      effect = new FlipBookSceneEffect();
      break;
    case 'RowSpread':
      effect = new RowSpreadSceneEffect();
      break;
    case 'Mosaic':
      effect = new MosaicSceneEffect();
      break;
    case 'None':
    default:
      effect = new NoneSceneEffect();
  }
  return effect;
};

export default CreateSceneEffect;



// WEBPACK FOOTER //
// ./src/components/draftPreview/sceneEffect.js